'use client'

import { useEffect } from 'react'
import { noop } from 'lodash'

export default function usePreventWindowUnload(
  preventDefault: boolean | (() => boolean),
  callback: () => void = noop,
) {
  useEffect(() => {
    function handleBeforeUnload(event: BeforeUnloadEvent) {
      const finalPreventDefault = typeof preventDefault === 'function' ? preventDefault() : true

      if (!finalPreventDefault) return false

      callback()

      event.preventDefault()

      // Workaround for chrome not supporting the above recommended way, for more details see https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
      event.returnValue = true // eslint-disable-line no-param-reassign

      return true
    }

    if (!preventDefault) return undefined

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [preventDefault, callback])
}
